import { Loader2 } from 'lucide-react'

export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  spinnerSize?: number
}

export const Loading = ({ text, spinnerSize = 32, ...rest }: LoadingProps) => {
  return (
    <div
      className="w-full h-auto px-8 py-4 gap-4 flex flex-col items-center justify-center"
      {...rest}
    >
      <Loader2 className="animate-spin text-muted-foreground" size={spinnerSize} />
      {text && <span className="text-muted-foreground">{text}</span>}
    </div>
  )
}
